import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';

// USAGE 
// Implement on each page in the application
// import { HostListener, ...} from '@angular/core';
// import { Observable } from 'rxjs/Observable';
//
// import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
// 
// .... variables, contructor and stuff and then the below code
//
// @HostListener('window:beforeunload')
// canDeactivate(): Observable<boolean> | boolean {
//    return true; // return true if no validation needs to be done on the page
//      or
//    return !this.isdirty; // return value of the page isDirty variable (set to true when a change to data has taken place)
//}

export interface ComponentCanDeactivate {
    canDeactivate: () => boolean | Observable<boolean>;
}

export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
    canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
        // if there are no pending changes, just allow deactivation; else confirm first
        return component.canDeactivate()
            ? true
            : confirm('You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/shared/page.pendingchangesguard.ts